import { render, staticRenderFns } from "./profileInfo.vue?vue&type=template&id=68aeae3a&"
import script from "./profileInfo.vue?vue&type=script&lang=js&"
export * from "./profileInfo.vue?vue&type=script&lang=js&"
import style0 from "./profileInfo.vue?vue&type=style&index=0&id=68aeae3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports